import React from 'react'
import Color from '../statics/colors'
class Icon extends React.Component {
  render() {
    const { width, height, color, icon } = this.props
    const svg = {
      passwordShow: () => {
        return (
          <svg
            height={height ? height : 16}
            width={width ? width : 16}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill="none"
              stroke={color ? color : '#323C47'}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="M0.55,8.187
            c0,0,6.868-10.649,14.9-0.116C15.45,8.07,8.291,18.141,0.55,8.187z"
            />
            <circle fill={color ? color : '#323C47'} cx="8" cy="8" r="2" />
          </svg>
        )
      },
      passwordHide: () => {
        return (
          <svg
            height={height ? height : 16}
            width={width ? width : 16}
            viewBox="0 0 16 16"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill="none"
              stroke={color ? color : '#323C47'}
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeMiterlimit="10"
              d="M0.55,8.187
            c0,0,6.868-10.649,14.9-0.116C15.45,8.07,8.291,18.141,0.55,8.187z"
            />
            <circle fill={color ? color : '#323C47'} cx="8" cy="8" r="2" />
            <line
              fill="none"
              stroke={color ? color : '#323C47'}
              strokeMiterlimit="10"
              x1="14.016"
              y1="1.287"
              x2="1.287"
              y2="14.016"
            />
            <line fill="none" stroke="#FFFFFF" strokeMiterlimit="10" x1="14.713" y1="1.985" x2="1.986" y2="14.712" />
          </svg>
        )
      },
      close: () => {
        return (
          <svg
            height={height ? height : 24}
            width={width ? width : 24}
            fill={color ? color : Color.grey}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        )
      },
      github: () => {
        return (
          <svg
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            height={height ? height : 24}
            width={width ? width : 24}>
            <path
              fill={color ? color : Color.grey}
              d="m256 0c-140.699219 0-256 116.300781-256 257 0 139.882812 114.25 255 256 255 141.574219 0 256-114.945312 256-255 0-140.699219-115.300781-257-256-257zm45 477.5c-14.398438 3-29.699219 4.5-45 4.5s-30.601562-1.5-45-4.5v-70.199219c0-16.800781 4.5-22.800781 10.5-30.902343 3.054688-3.492188 4.898438-6.625 18.597656-27.296876l-23.097656-3.601562c-59.402344-8.699219-82.800781-39.601562-92.101562-63.601562-12-32.097657-5.699219-72.300782 15.902343-97.796876 3.300781-3.902343 6-10.503906 3.601563-17.402343-4.503906-13.800781-3.902344-35.699219-.902344-44.101563 15.90625 2.273438 32.261719 13.667969 45.902344 21.902344 6.285156 3.667969 9.582031 2.699219 12.597656 3 10.960938-2.28125 28.058594-7.800781 54.300781-7.800781 16.199219 0 33.300781 2.398437 50.101563 7.199219 3.003906-.070313 7.832031 2.484374 16.199218-2.398438 14.257813-8.6875 30.058594-19.691406 45.898438-21.902344 3 8.402344 3.601562 30.300782-.898438 44.101563-2.402343 6.898437.296876 13.5 3.601563 17.402343 21.597656 25.5 27.898437 65.699219 15.898437 97.796876-9.300781 24-32.699218 54.902343-92.101562 63.601562l-23.097656 3.601562c14.160156 21.367188 15.652344 23.929688 18.601562 27.296876 5.996094 8.101562 10.496094 14.101562 10.496094 30.902343zm30-8.699219v-61.5c0-17.101562-3.601562-28.5-8.402344-36.902343 45.601563-12.296876 78.003906-39.300782 92.402344-78 15.300781-40.796876 8.402344-89.398438-17.101562-123 4.503906-20.097657 4.503906-52.199219-6.296876-67.199219-4.800781-6.597657-11.402343-10.199219-19.800781-10.199219-.300781 0-.300781 0-.300781 0-23.261719 1.257812-41.570312 12.972656-61.199219 24.898438-18-4.800782-36.300781-7.199219-54.601562-7.199219-18.597657 0-37.199219 2.699219-53.695313 7.199219-20.664062-12.460938-38.796875-23.671876-62.703125-24.898438-7.5 0-14.101562 3.601562-18.902343 10.199219-10.796876 15-10.796876 47.101562-6.296876 67.199219-25.503906 33.601562-32.402343 82.5-17.101562 123 14.398438 38.699218 46.800781 65.703124 92.402344 78-3.722656 6.511718-6.667969 14.914062-7.828125 26.285156-9.210938 3.175781-17.199219 4.210937-24.628907 2.027344-7.835937-2.316407-13.941406-7.546876-19.246093-16.46875-11.914063-20.015626-32.207031-36.355469-55.3125-34.230469l2.636719 29.882812c10.699218-.980469 21.347656 10.339844 26.878906 19.671875 9.125 15.367188 21.417968 25.445313 36.546875 29.914063 11.230469 3.308593 21.496093 3.230469 32.550781.871093v40.449219c-87.300781-30.601562-151-114-151-211.800781 0-124.199219 101.800781-227 226-227s226 102.800781 226 227c0 97.800781-63.699219 181.199219-151 211.800781zm0 0"
            />
          </svg>
        )
      },
      facebook: () => {
        return (
          <svg
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            height={height ? height : 24}
            width={width ? width : 24}>
            <path
              fill={color ? color : Color.grey}
              d="m75 512h167v-182h-60v-60h60v-75c0-41.355469 33.644531-75 75-75h75v60h-60c-16.542969 0-30 13.457031-30 30v60h87.292969l-10 60h-77.292969v182h135c41.355469 0 75-33.644531 75-75v-362c0-41.355469-33.644531-75-75-75h-362c-41.355469 0-75 33.644531-75 75v362c0 41.355469 33.644531 75 75 75zm-45-437c0-24.8125 20.1875-45 45-45h362c24.8125 0 45 20.1875 45 45v362c0 24.8125-20.1875 45-45 45h-105v-122h72.707031l20-120h-92.707031v-30h90v-120h-105c-57.898438 0-105 47.101562-105 105v45h-60v120h60v122h-137c-24.8125 0-45-20.1875-45-45zm0 0"
            />
          </svg>
        )
      },
      twitter: () => {
        return (
          <svg version="1.1" id="Capa_1" viewBox="0 0 612 612" height={height ? height : 24} width={width ? width : 24}>
            <g>
              <path
                fill={color ? color : Color.grey}
                d="M437.219,245.162c0-3.088-0.056-6.148-0.195-9.18c13.214-9.848,24.675-22.171,33.744-36.275
             c-12.129,5.453-25.148,9.097-38.835,10.626c13.965-8.596,24.675-22.338,29.738-38.834c-13.075,7.928-27.54,13.603-42.924,16.552
             c-12.323-14.021-29.904-22.95-49.35-23.284c-37.332-0.612-67.598,30.934-67.598,70.463c0,5.619,0.584,11.072,1.752,16.329
             c-56.22-3.616-106.042-32.881-139.369-77c-5.814,10.571-9.152,22.922-9.152,36.164c0,25.037,11.934,47.291,30.071,60.421
             c-11.099-0.5-21.503-3.866-30.627-9.375c0,0.306,0,0.612,0,0.918c0,34.996,23.312,64.316,54.245,71.159
             c-5.675,1.613-11.656,2.448-17.804,2.421c-4.367-0.028-8.596-0.501-12.713-1.392c8.596,28.681,33.577,49.628,63.147,50.323
             c-23.145,19.194-52.298,30.655-83.955,30.572c-5.453,0-10.849-0.361-16.135-1.029c29.933,20.53,65.456,32.491,103.65,32.491
             C369.23,447.261,437.219,339.048,437.219,245.162z"
              />
              <path
                fill={color ? color : Color.grey}
                d="M612,306C612,137.004,474.995,0,306,0C137.004,0,0,137.004,0,306c0,168.995,137.004,306,306,306
             C474.995,612,612,474.995,612,306z M27.818,306C27.818,152.36,152.36,27.818,306,27.818S584.182,152.36,584.182,306
             S459.64,584.182,306,584.182S27.818,459.64,27.818,306z"
              />
            </g>
          </svg>
        )
      },
      linkedin: () => {
        return (
          <svg
            height={height ? height : 24}
            width={width ? width : 24}
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill={color ? color : Color.grey}
              d="m382 492h-352c-5.515625 0-10-4.484375-10-10v-452c0-5.515625 4.484375-10 10-10h20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-20c-16.542969 0-30 13.457031-30 30v452c0 16.542969 13.457031 30 30 30h352c5.519531 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
            />
            <path
              fill={color ? color : Color.grey}
              d="m482 0h-352c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h352c5.515625 0 10 4.484375 10 10v452c0 5.515625-4.484375 10-10 10h-20c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h20c16.542969 0 30-13.460938 30-30v-452c0-16.542969-13.457031-30-30-30zm0 0"
            />
            <path
              fill={color ? color : Color.grey}
              d="m123.25 176.75c29.085938 0 52.75-23.664062 52.75-52.75 0-29.089844-23.664062-52.75-52.75-52.75-29.089844 0-52.75 23.664062-52.75 52.75s23.660156 52.75 52.75 52.75zm0-85.5c18.058594 0 32.75 14.691406 32.75 32.75s-14.691406 32.75-32.75 32.75-32.75-14.691406-32.75-32.75 14.691406-32.75 32.75-32.75zm0 0"
            />
            <path
              fill={color ? color : Color.grey}
              d="m344.25 181.75c-22.101562 0-43.433594 7.6875-60.5 21.273438v-6.273438c0-5.523438-4.480469-10-10-10h-69.75c-5.523438 0-10 4.476562-10 10v234c0 5.523438 4.476562 10 10 10h73.5c5.519531 0 10-4.476562 10-10v-135.0625c0-16.679688 13.570312-30.25 30.25-30.25s30.25 13.570312 30.25 30.25v135.0625c0 5.523438 4.476562 10 10 10h73.5c5.519531 0 10-4.476562 10-10v-151.75c0-53.625-43.628906-97.25-97.25-97.25zm77.25 239h-53.5v-125.0625c0-27.707031-22.542969-50.25-50.25-50.25-27.710938 0-50.25 22.542969-50.25 50.25v125.0625h-53.5v-214h49.75v21.011719c0 4.328125 2.78125 8.164062 6.898438 9.507812 4.109374 1.339844 8.625-.117187 11.175781-3.613281 14.585937-19.976562 37.921875-31.90625 62.425781-31.90625 42.59375 0 77.25 34.652344 77.25 77.25zm0 0"
            />
            <path
              fill={color ? color : Color.grey}
              d="m86.5 186.75c-5.523438 0-10 4.476562-10 10v234c0 5.523438 4.476562 10 10 10h73.5c5.519531 0 10-4.476562 10-10v-234c0-5.523438-4.480469-10-10-10zm63.5 234h-53.5v-214h53.5zm0 0"
            />
            <path
              fill={color ? color : Color.grey}
              d="m90.003906 20c5.519532 0 10-4.476562 10-10s-4.480468-10-10-10h-.007812c-5.523438 0-9.996094 4.476562-9.996094 10s4.480469 10 10.003906 10zm0 0"
            />
            <path
              fill={color ? color : Color.grey}
              d="m422.003906 492h-.007812c-5.523438 0-9.996094 4.476562-9.996094 10s4.480469 10 10.003906 10c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"
            />
          </svg>
        )
      },
      instagram: () => {
        return (
          <svg
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            height={height ? height : 24}
            width={width ? width : 24}
            viewBox="0 0 49.652 49.652">
            <g>
              <path
                fill={color ? color : Color.grey}
                d="M24.825,29.796c2.739,0,4.972-2.229,4.972-4.97c0-1.082-0.354-2.081-0.94-2.897c-0.903-1.252-2.371-2.073-4.029-2.073
     c-1.659,0-3.126,0.82-4.031,2.072c-0.588,0.816-0.939,1.815-0.94,2.897C19.854,27.566,22.085,29.796,24.825,29.796z"
              />
              <polygon points="35.678,18.746 35.678,14.58 35.678,13.96 35.055,13.962 30.891,13.975 30.907,18.762 			" />
              <path
                fill={color ? color : Color.grey}
                d="M24.826,0C11.137,0,0,11.137,0,24.826c0,13.688,11.137,24.826,24.826,24.826c13.688,0,24.826-11.138,24.826-24.826
     C49.652,11.137,38.516,0,24.826,0z M38.945,21.929v11.56c0,3.011-2.448,5.458-5.457,5.458H16.164
     c-3.01,0-5.457-2.447-5.457-5.458v-11.56v-5.764c0-3.01,2.447-5.457,5.457-5.457h17.323c3.01,0,5.458,2.447,5.458,5.457V21.929z"
              />
              <path
                fill={color ? color : Color.grey}
                d="M32.549,24.826c0,4.257-3.464,7.723-7.723,7.723c-4.259,0-7.722-3.466-7.722-7.723c0-1.024,0.204-2.003,0.568-2.897
     h-4.215v11.56c0,1.494,1.213,2.704,2.706,2.704h17.323c1.491,0,2.706-1.21,2.706-2.704v-11.56h-4.217
     C32.342,22.823,32.549,23.802,32.549,24.826z"
              />
            </g>
          </svg>
        )
      },
      default: () => {
        return (
          <svg
            fill={color ? color : '#cccccc'}
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z" />
          </svg>
        )
      }
    }
    return svg[icon || 'default']()
  }
}

export default Icon
